// extracted by mini-css-extract-plugin
module.exports = {"under_one_min":"TimeAgo_under_one_min__ezPjZ"};